import { DtoBase } from "../DtoBase";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { ValueEncoder } from "../../DiscoveryEngine.TS/Utils/ValueEncoder";

export class GetAlertsRequestDto extends DtoBase {

	public ScopeGuid: string;
	public AgentGuid: string;
	public ClientAgentGuid: string;
	public Category: string;
	public Source: string;
	public Type: string;
	public Description: string;
	public SortBy: string;
	public Ascending: boolean;
	public Skip: number;
	public Limit: number;

	constructor() {
		super();

		this.ScopeGuid = "";
		this.AgentGuid = "";
		this.ClientAgentGuid = "";
		this.Category = "";
		this.Source = "";
		this.Type = "";
		this.Description = "";
		this.SortBy = "";
		this.Ascending = false;
		this.Skip = 0;
		this.Limit = 0;
	}

	public get HasScopeGuid(): boolean {
		return !!this.ScopeGuid;
	}

	public get HasAgentGuid(): boolean {
		return !!this.AgentGuid;
	}

	public get HasClientAgentGuid(): boolean {
		return !!this.ClientAgentGuid;
	}

	public get HasCategory(): boolean {
		return !!this.Category;
	}

	public get HasSource(): boolean {
		return !!this.Source;
	}

	public get HasType(): boolean {
		return !!this.Type;
	}

	public get HasDescription(): boolean {
		return !!this.Description;
	}

	public get HasSortBy(): boolean {
		return !!this.SortBy;
	}

	public get HasSkip(): boolean {
		return (this.Skip > 0);
	}

	public get HasLimit(): boolean {
		return (this.Limit > 0);
	}

	public Write(obj: any, context: any): void {
		obj.get_events_request = {};
		obj = obj.get_events_request;

		super.Write(obj, context);

		if (this.HasScopeGuid)
			obj.scope_guid = this.ScopeGuid;

		if (this.HasAgentGuid)
			obj.agent_guid = this.AgentGuid;

		if (this.HasClientAgentGuid)
			obj.client_agent_guid = this.ClientAgentGuid;

		if (this.HasCategory)
			obj.category = this.Category;

		if (this.HasSource)
			obj.source = this.Source;

		if (this.HasType)
			obj.type = this.Type;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasSortBy)
			obj.sort_by = this.SortBy;

		obj.ascending = ValueEncoder.EncodeBoolean(this.Ascending);

		if (this.HasSkip)
			obj.skip = ValueEncoder.EncodeInteger(this.Skip);

		if (this.HasLimit)
			obj.limit = ValueEncoder.EncodeInteger(this.Limit);
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_events_request)
			throw new Error();
		obj = obj.get_events_request;

		super.Read(obj, context);

		if (obj.scope_guid !== undefined)
			this.ScopeGuid = obj.scope_guid;

		if (obj.agent_guid !== undefined)
			this.AgentGuid = obj.agent_guid;

		if (obj.client_agent_guid !== undefined)
			this.ClientAgentGuid = obj.client_agent_guid;

		if (obj.category !== undefined)
			this.Category = obj.category;

		if (obj.source !== undefined)
			this.Source = obj.source;

		if (obj.type !== undefined)
			this.Type = obj.type;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.sort_by !== undefined)
			this.SortBy = obj.sort_by;

		if (obj.ascending !== undefined)
			this.Ascending = ValueEncoder.DecodeBoolean(obj.ascending);

		if (obj.skip !== undefined)
			this.Skip = ValueEncoder.DecodeInteger(obj.skip);

		if (obj.limit !== undefined)
			this.Limit = ValueEncoder.DecodeInteger(obj.limit);
	}

}
